/** Estilos de campos solo lectura (mismo criterio que DatosCli / detalle clientes). */
export const readonlyTextFieldVariant = "filled";

export const readonlyTextFieldSx = {
  "& .MuiFilledInput-root": {
    backgroundColor: "#f0f0f0",
    "&:before": {
      borderBottomColor: "primary.main",
    },
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
    "&.Mui-focused": {
      backgroundColor: "#f0f0f0",
    },
  },
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#f0f0f0",
  },
  "& .MuiInputBase-input": {
    color: "#000",
    WebkitTextFillColor: "#000",
  },
  "& .MuiInputLabel-root": {
    color: "primary.main",
  },
};

export const readonlyContainerSx = {
  "& .MuiTextField-root .MuiOutlinedInput-root, & .MuiTextField-root .MuiFilledInput-root": {
    backgroundColor: "#f0f0f0 !important",
  },
  "& .MuiTextField-root .MuiInputBase-input": {
    color: "#000 !important",
    WebkitTextFillColor: "#000 !important",
  },
  "& .MuiTextField-root .MuiInputLabel-root": {
    color: "primary.main",
  },
  "& .MuiFormControl-root .MuiInputBase-root.Mui-disabled": {
    backgroundColor: "#f0f0f0",
  },
  "& .MuiFormControl-root .MuiSelect-select.Mui-disabled, & .MuiFormControl-root .MuiInputBase-input.Mui-disabled":
    {
      color: "#000 !important",
      WebkitTextFillColor: "#000 !important",
    },
  "& .MuiFormControl-root .MuiInputLabel-root.Mui-disabled": {
    color: "primary.main",
  },
  "& .MuiCheckbox-root.Mui-disabled": {
    color: "primary.main !important",
  },
  "& .MuiRadio-root.Mui-disabled": {
    color: "primary.main !important",
  },
};

export const getReadonlyTextFieldProps = () => ({
  variant: readonlyTextFieldVariant,
  InputProps: { readOnly: true },
  inputProps: { readOnly: true },
  sx: readonlyTextFieldSx,
});
